import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseTasksStatusPayload } from '../payloads/tasksStatusPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import intl from 'react-intl-universal';

export const buildTasksStatusInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseTasksStatusPayload(payload);
  const { aggregate, data } = parsedPayload.data.attributes;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.V_BAR)
      .setProps({
        chartData: data as BarChartData,
        onDrillDown: props.onDrillDown,
        xAxisFieldName: 'task_status',
        yAxisFieldNames: ['task_count'],
        legendNames: [intl.get('INSIGHT.LEGEND.TASK_COUNT')],
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
      trendData: {
        value: aggregate.total_tasks.current ?? 0,
        trend: aggregate.total_tasks.percentage_change ?? 0,
        trendIsPercent: true,
        description: props.name,
      },
    });
  };
};
